<!-- 我的卡券-->
<template>
    <div class="root-wrap">
        <div class="body-wrap fx-fill">
            <div class="fill-box">
                <van-tabs v-model="activeIndex" class="fx-column" :color="$config.style.primaryColor" :scrollspy="false" :lazy-render="false" sticky :ellipsis="false" style="height: 100%;" @change="initPage">
                    <div style="padding: 7px;">
                        <van-button block @click="showAdd = true">
                            <template #icon>
                                <van-icon name="add-o" :color="$config.style.primaryColor"></van-icon>
                            </template>
                            <span>添加卡券</span>
                        </van-button>
                    </div>
                    <van-tab :title="couponListTitle">
                        <div class="movie_tab-wrap fill-box" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0">
                            <van-empty v-if="couponList.length < 1" :image="require('@/assets/images/user/user_card_empty.png')" description="暂无卡券"></van-empty>
                            <div v-else>
                                <user-card v-for="item, index in couponList" :key="index" :card="item" @click-info="showInfoDialog"></user-card>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab :title="exchangeCardListTitle">
                        <div class="movie_tab-wrap fill-box" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0">
                            <van-empty v-if="exchangeCardList.length < 1" :image="require('@/assets/images/user/user_card_empty.png')" description="暂无卡券"></van-empty>
                            <div v-else>
                                <user-card v-for="item, index in exchangeCardList" :key="index" :card="item" @click-info="showInfoDialog"></user-card>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
        <div class="utils-wrap">
            <user-card-dialog v-model="showAdd" @confirm="confirmAdd"></user-card-dialog>
            <card-info-dialog v-model="showInfo" :card="cardInfo" :name="cardName"></card-info-dialog>
        </div>
    </div>
</template>

<script>
import UserCard from '@/components/user/user-card';
import UserCardDialog from '@/components/user/user-card-dialog';
import CardInfoDialog from '@/components/user/card-info-dialog';
export default {
    data() {
        return {
            activeIndex: 0,
            couponList: [],
            exchangeCardList: [],
            pagination: this.$config.getDefaultPagination(),
            showAdd: false,
            showInfo: false,
            cardInfo: null,
            cardName: null,
        }
    },
    computed: {
        couponListTitle() {
            return this.couponList.length > 0 ? `优惠券(${this.couponList.length})` : '优惠券'
        },
        exchangeCardListTitle() {
            return this.exchangeCardList.length > 0 ? `兑换券(${this.exchangeCardList.length})` : '兑换券';
        }
    },
    methods: {
        showInfoDialog(card, cardName) {
            this.cardName = cardName;
            this.$service.getCouponInfo({ cardno: card.cardno }).then((res) => {
                this.cardInfo = res;
                this.showInfo = true;
            });
        },
        //获取兑换券
        getDCouponList() {
            return new Promise((resolve) => {
                let params = {
                    type: 'D',
                    page_no: this.pagination.current_page,
                    per: 20,
                }
                this.$service.getMemberCouponList(params).then((res) => {
                    this.pagination = res.pagination;
                    this.exchangeCardList = this.exchangeCardList.concat(res.couponlist);
                    this.exchangeCardList.sort((last) => last.status == 'L' ? 1 : -1);
                    resolve();
                });
            })
        },
        //获取优惠券
        getACouponList() {
            return new Promise((resolve) => {
                let params = {
                    type: 'A',
                    page_no: this.pagination.current_page,
                    per: 20,
                }
                this.$service.getMemberCouponList(params).then((res) => {
                    this.pagination = res.pagination;
                    this.couponList = this.couponList.concat(res.couponlist);
                    this.couponList.sort((last) =>  last.status == 'L' ? 1 : -1);
                    resolve();
                });
            })
        },
        loadMore() {
            if (this.pagination.next) {
                ++this.pagination.current_page;
                if (this.activeIndex == 0) {
                    this.getACouponList();
                } else if (this.activeIndex == 1) {
                    this.getDCouponList();
                }
            }
        },
        confirmAdd(val) {
            let loading = this.$toast.loading('绑定中');
            let params = {
                cardpass: val,
                showtype: 'Y'
            }
            this.$service.bindCoupon(params).then((res) => {
                let type = res.type;
                loading.clear();
                this.showAdd = false;
                if (type === 'VIP') {
                    this.$goPage('user-vip');
                    return;
                }
                this.initPage(type);
            });
        },
        initPage(type) {
            this.pagination = this.$config.getDefaultPagination();
            this.couponList = [];
            this.exchangeCardList = [];
            let loading = this.$toast.loading(this.$config.loadingMsg);
            Promise.all([this.getACouponList(), this.getDCouponList()]).then((res) => {
                if (type == 'A') {
                    this.activeIndex = 0;
                } else if (type == 'D') {
                    this.activeIndex = 1;
                }
                loading.clear();
            });
        }
    },
    mounted() {
        this.initPage();
    },
    components: {
        UserCard,
        UserCardDialog,
        CardInfoDialog
    }
}
</script>

<style lang="scss" scoped>
.body-wrap {
	position: relative;
	height: 0px;
	overflow: hidden;
	/deep/ .van-tabs__content {
		flex: 1;
		display: flex;
		flex-direction: column;
		.van-tab__pane {
			flex: 1;
			position: relative;

			.movie_tab-wrap {
				padding: 0 7px;
			}
		}
	}
}
.utils-wrap {
}
</style>